
  import {createControllersWithDescriptors, initAppForPageWrapper} from '@wix/yoshi-flow-editor/runtime/esm/viewerScript/wrapper.js';
  
  

  
  var importedApp = {};


  

    import { initState, initBind } from '@wix/yoshi-flow-editor/runtime/esm/velocycleMobx';
    import { observable } from 'mobx';
    var velocycleMobx = { initState, initBind, observable };
    


  

    var blocksControllerService = null;
    

  
var createHttpClient = null;

  

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


  
const multilingualDisabled = false;

  

    var createExperiments = null;
    var createWidgetExperiments = null;
    


  var sentryConfig = {
      DSN: 'https://bcea6319e2dd4b1aaecfde5bec98f9ed@sentry.wixpress.com/6129',
      id: 'undefined',
      projectName: 'adsense-editor-ooi-62',
      teamName: 'adsense-editor-ooi-',
      errorMonitor: true,
    };

  var experimentsConfig = {"scopes":["test"],"centralized":true};

  var translationsConfig = {"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/d55b1af2257c953d/packages/adsense-editor-ooi/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};

  var defaultTranslations = {"adsense.settings.tab.main":"Main","adsense.settings.tab.adunits":"Ad Units","adsense.settings.tab.support":"Support","adsense.settings.main.state.manage_ads":"Manage Ads","adsense.settings.main.state.duplicate_ad":"Duplicate Ad","adsense.settings.main.state.go_to_dashboard":"Manage Ads","adsense.settings.main.state.disconnected.text":"Connect your Google AdSense account to start running ads on your site.","adsense.settings.main.state.connected_pending.banner_text":"Your site’s being reviewed by Google. You’ll receive an email when you can connect ad units.","adsense.settings.main.state.connected_no_ads.connect_ad_unit":"Connect Ad Unit","adsense.settings.main.state.connected_no_ads.create_ad_unit":"Create Ad Unit","adsense.settings.main.state.text":"Place AdSense ads on your site and get paid for impressions.","adsense.settings.main.state.connect_account_for_migrated_users.connect_adsense":"Connect AdSense","adsense.settings.main.state.connect_account_for_migrated_users.title":"Welcome to the new Wix Monetize with AdSense","adsense.settings.main.state.connect_account_for_migrated_users.text":"Connect your AdSense account to enjoy new feature releases and manage all your ads in one place.","adsense.settings.ad_units.connected_with_ads.title":"Existing ad units","adsense.settings.ad_units.connected_with_ads.text":"Connect an existing ad unit to your site or create a new one.","adsense.settings.ad_units.connected_with_ads.tooltip":"Responsive ad units can be resized in the Editor. Fixed-sized ads can be resized in the 'Manage Ads' dashboard.","adsense.settings.ad_units.connected_with_ads.size":"Size: ","adsense.settings.ad_units.connected_with_ads.dimensions":"{w}X{h} px","adsense.settings.ad_units.connected_with_ads.responsive":"Responsive","adsense.settings.ad_units.connected_with_ads.manage_ads":"Manage Ads","adsense.settings.ad_units.empty_state.title":"Create your first ad unit","adsense.settings.ad_units.empty_state.text":"Choose from fixed ad units or create a custom size, then place it anywhere on your site.","adsense.settings.ad_units.empty_state.newAdUnit":"+ New Ad Unit","adsense.settings.ad_units.mobile.title":"AdSense ads on mobile","adsense.settings.ad_units.mobile.text":"Ads viewed on mobile have a fixed size of 300x250 px. To connect ad units, switch to edit mode for desktop.","adsense.settings.support.got_a_question":"Got a Question?","adsense.settings.support.technical_assistant.text":"Technical problems? Troubleshoot \n common errors and issues.","adsense.settings.support.technical_assistant.link":"Wix Technical Assistant","adsense.settings.support.google_adsense_help.text":"Get more information about Google AdSense.","adsense.settings.support.google_adsense_help.link":"Google Adsense Help","adsense.settings.support.customer_care.text":"Still having issues? Contact us for assistance.","adsense.settings.support.customer_care.link":"Contact Customer Care","adsense.settings.support.help_center":"Help Center","adsense.settings.support.help_center.title":"About Google AdSense","adsense.settings.support.help_center.description":"Google AdSense provides a way for site owners to earn money from their content. AdSense works by matching ads to your site content and relevant visitor interests. The ads are created and paid for by advertisers who want to promote their products. Since these advertisers pay different prices for different ads, the amount you earn will vary on impressions.","adsense.settings.support.help_center.read_more":"Read More","adsense.settings.support.help_center.read_less":"Read Less","adsense.settings.support.help_center.how_to_duplicate_ads_on_a_page":"How to Duplicate Ads on a Page","adsense.settings.support.help_center.adding_and_setting_up_ads":"Adding and Setting Up Ads","adsense.settings.support.help_center.how_to_connect_ad_units":"How to Connect Ad Units","adsense.settings.support.help_center.see_all_articles":"See All Articles","adsense.widget.header.title":"Wix Monetize with AdSense","adsense.widget.header.text.default":"Ads will be displayed here.","adsense.widget.header.text.alert":"When an ad unit is connected,\n ads will be displayed here.","adsense.widget.header.text.success":"Ads will be displayed here.","adsense.widget.sectionNotification.default":"Connect your Google AdSense account to display ads.","adsense.widget.sectionNotification.alert":"No ad unit is connected.","adsense.widget.sectionNotification.success":"Your ad unit is connected.","adsense.widget.sectionNotification.adName.isConnected":"‘{adName}’ is connected.","adsense.widget.title_small_preset":"AdSense"};

  var fedopsConfig = null;

  import { createVisitorBILogger as biLogger } from '/home/builduser/work/d55b1af2257c953d/packages/adsense-editor-ooi/target/generated/bi/createBILogger.ts';

  export const exports = importedApp.exports;

  export const initAppForPage = initAppForPageWrapper({
    initAppForPage: importedApp.initAppForPage,
    sentryConfig: sentryConfig,
    experimentsConfig: experimentsConfig,
    inEditor: false,
    biLogger: biLogger,
    multilingualDisabled,
    projectName: "adsense-editor-ooi",
    biConfig: null,
    appName: "adsense",
    appDefinitionId: "12d5833e-f061-7cc8-5122-e1d404f6c8ae",
    fedopsConfig: fedopsConfig,
    translationsConfig: translationsConfig,
    defaultTranslations: defaultTranslations,
    shouldUseEssentials: true,
    optionalDeps: {
      initI18n,
      createHttpClient,
      createExperiments,
    },
    localeDistPath: "assets/locales",
  });

  const _createControllers = createControllersWithDescriptors({
    initI18n,
    blocksControllerService,
    createHttpClient,
    createExperiments,
    velocycleMobx,
  }, [{ method: null,
          wrap: null,
          exports: null,
          widgetType: "WIDGET_OUT_OF_IFRAME",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"scopes":["test"],"centralized":true},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/d55b1af2257c953d/packages/adsense-editor-ooi/src/components/adsense/controller.ts",
          appName: "adsense",
          appDefinitionId: "12d5833e-f061-7cc8-5122-e1d404f6c8ae",
          projectName: "adsense-editor-ooi",
          componentName: "adsense",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "10d35619-006d-4c99-a09d-f4c508533e3f" }],
    false);

    export const createControllers = _createControllers
